import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCPwNkERQwhVA0XwMdc02vGsbjmqRvWbaY",
  authDomain: "bingo-game-485b8.firebaseapp.com",
  projectId: "bingo-game-485b8",
  storageBucket: "bingo-game-485b8.appspot.com",
  messagingSenderId: "743807864194",
  appId: "1:743807864194:web:63c685b30af74cdbd0539b",
  measurementId: "G-E3LXDDDSZ9",
};

let firebaseApp;

if (!firebase.apps.length) {
  firebaseApp = firebase.initializeApp(firebaseConfig);
} else {
  firebaseApp = firebase.app();
}

export const db = firebase.firestore();

export default firebaseApp;
